const events = [
    'ALLOWED_FLEETS',
    'FLEET_FILTER_INFO',
    'FLEET_CURRENT_FILTER',
    'FLEET_DETAILS_PAGE_ACTIVE',
    'GLOBAL_SETTINGS',
    'HEADER_BUTTON_CLICKED',
    'HEIGHT_CHANGED',
    'HIDE_NOTIFICATION',
    'NOTIFICATION',
    'ON_PARENT_WINDOW_RESIZED',
    'ON_MODAL_STATUS_CHANGE',
    'PERMISSIONS',
    'TOGGLE_LOADING_BAR',
    'URL_PARAMS_MANUALLY_UPDATED',
    'URL_PARAMS_UPDATED',
    'URL_PATH_UPDATED',
    'WINDOW_RESIZED_IS_SMALL',
    'DESKTOP_NOTIFICATION',
    'USER_TOKEN',
    'WINDOW_LOCATION',
    'VEHICLE_DETAILS',
    'CURRENT_FLEET'
];

const result = { };
events.forEach(key => {
    result[key] = key;
});

export default result;